<script>
  import { createEventDispatcher, onMount } from "svelte";
  import JobCardPrint from "./JobCardPrint.svelte";
  import axios from "axios";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import config from "../../stores/config";
  import Select from "svelte-select";
  import { Wave } from "svelte-loading-spinners";
  import * as ls from "local-storage";
  import QuillEditor from "../../shared/QuillEditor.svelte";
  import { slide } from "svelte/transition";

  let showPrint = false;

  const dispatch = createEventDispatcher();
  //...............................................................................
  export let _id;
  export let jobType;

  // ALL DEPARTMENTS
  export let customerID;
  export let orderID;
  export let delDate;

  // CABINETRY DEPARTMENT + MACHINE DEPARTMENT ----------------------
  export let department;
  export let departmentTask;
  export let sprayPaint;

  // CABINETRY DEPARTMENT ONLY: NONE -------------------
  // MACHINE DEPARTMENT ----------------------
  export let foam;
  export let assembly;

  // MACHINIST --------------------------------
  export let machinist;
  export let description;
  export let framing;
  export let upholsterer;
  export let quality;
  export let fabricInfo;
  export let notes;
  export let repFoaming;
  export let meterage;
  export let cutter;
  export let cushions;

  // MACHINIST names...............
  export let framingFN;
  export let foamingFN;
  export let fabricInfoFN;
  export let cushionsFN;
  export let cutterFN;
  export let meterigeFN;
  export let qualityFN;

  //...............................................................................
  let uploading = false;
  let TYPES_ARR = [
    { value: "1", label: "CABINETRY CARD TEMPLATE" },
    { value: "2", label: "FRAME CARD TEMPLATE" },
    { value: "3", label: "FLOOR CARD TEMPLATE" },
  ];

  let type;

  const handleClear = () => {};

  const handleSubmit = async (e) => {
    if (1 > 2) alert("Something is missing");
    // else if (!type) alert("type missing!");
    else if (!jobType) alert("type missing!");
    else {
      uploading = true;

      // Infered Fields:
      if (jobType == "1") department = "CABINETRY DEP";
      else if (jobType == "2") department = "MACHINE DEP";
      // if (type?.value == "1") department = "CABINETRY DEP";
      // else if (type?.value == "2") department = "MACHINE DEP";

      let data = {
        // type: type?.value,
        type: jobType,
        delDate,
        department,
        departmentTask,
        sprayPaint,
        foam,
        assembly,
        machinist,
        description,
        framing,
        upholsterer,
        quality,
        fabricInfo,
        notes,
        repFoaming,
        meterage,
        cutter,
        cushions,
        framingFN,
        foamingFN,
        fabricInfoFN,
        cushionsFN,
        cutterFN,
        meterigeFN,
        qualityFN,
      };

      axios
        .put(`${$config.backendURL}/fstyles/${_id}`, data, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          uploading = false;
          dispatch("reloadData");
          alert(`☑ Updated Successfully`);
        })
        .catch((err) => {
          alert("There was a problem, Refresh the page and retry");
          console.log(err);
          uploading = false;
        });
    }
  };

  onMount(() => {
    // console.log(_id);
  });
</script>

<svelte:head>
  <title>Edit Stock Item — Supreme Upholstery System</title>
</svelte:head>

<button
  on:click={() => (showPrint = true)}
  class="btn btn-primary uppercase absolute right-48"
  style="top: 10px"
>
  <i class="fas fa-print mr-2" />
  Print
</button>

<MenuHeading
  title="Job Card Details"
  description="Edit Job Card details here"
/>

<form
  on:submit|preventDefault={handleSubmit}
  class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
>
  <div class="grid grid-cols-2 gap-2">
    <div class="flex flex-col">
      <div class="uppercase">Job Card Type:</div>
      <div class="col-span-3">
        <Select
          items={TYPES_ARR}
          on:select={(e) => {
            type = e.detail;
            jobType = type.value;
          }}
          selectedValue={jobType}
        />
      </div>
    </div>
    {#if jobType}
      <div class="flex items-center justify-center uppercase pt-4 text-base">
        🔳 {TYPES_ARR[Number.parseInt(jobType) - 1]?.label} 🔳
      </div>
    {/if}
  </div>

  <div in:slide={{ duration: 500, y: -100 }} class="grid grid-cols-2 gap-2">
    <!-- FIELDS SCOPE: EVERYONE -->
    <div class="flex flex-col">
      <div>Del Date :</div>
      <input
        class="col-span-3 shadow-sm placeholder-gray-300"
        type="date"
        bind:value={delDate}
      />
    </div>
    <!-- FIELDS SCOPE: MACHINIST -->
    {#if jobType == "3"}
      <div class="flex flex-col">
        <div class="uppercase">Machinist :</div>
        <input
          class="col-span-3 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={machinist}
        />
      </div>
    {/if}
  </div>

  <!-- FIELDS SCOPE: CABINET OR MACHINE -->
  <div in:slide={{ duration: 500, y: -100 }} class="grid grid-cols-2 gap-2">
    {#if jobType == "1" || jobType == "2"}
      <div class="flex flex-col">
        <div class="uppercase">
          {jobType == "1" ? "CABINETRY DEP:" : "MACHINE DEP:"}
        </div>
        <textarea
          class="col-span-3 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={departmentTask}
          rows="4"
        />
      </div>
      <div class="flex flex-col">
        <div class="uppercase">Spray/Paint :</div>
        <textarea
          class="col-span-3 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={sprayPaint}
          rows="4"
        />
      </div>
    {/if}
  </div>

  <!-- FIELDS SCOPE: MACHINE -->
  {#if jobType == "2"}
    <div in:slide={{ duration: 500, y: -100 }} class="grid grid-cols-2 gap-2">
      <div class="flex flex-col">
        <div class="uppercase">Foam:</div>
        <textarea
          class="col-span-3 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={foam}
          rows="4"
        />
      </div>
      <div class="flex flex-col">
        <div class="uppercase">Assembly:</div>
        <textarea
          class="col-span-3 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={assembly}
          rows="4"
        />
      </div>
    </div>
  {/if}

  <!-- FIELDS SCOPE: MACHINIST -->
  {#if jobType == "3"}
    <!-- Names here here here -->
    <div in:slide={{ duration: 500, y: -100 }} class="grid grid-cols-2 gap-2">
      <div class="flex flex-col">
        <div class="uppercase">Full Name - Framing:</div>
        <input class="col-span-3" type="text" bind:value={framingFN} />
      </div>
      <div class="flex flex-col">
        <div class="uppercase">Full Name - Foaming:</div>
        <input class="col-span-3" type="text" bind:value={foamingFN} />
      </div>
    </div>
    <div in:slide={{ duration: 500, y: -100 }} class="grid grid-cols-2 gap-2">
      <div class="flex flex-col">
        <div class="uppercase">Full Name - Fabric INFO:</div>
        <input class="col-span-3" type="text" bind:value={fabricInfoFN} />
      </div>
      <div class="flex flex-col">
        <div class="uppercase">Full Name - Cushions:</div>
        <input class="col-span-3" type="text" bind:value={cushionsFN} />
      </div>
    </div>
    <div in:slide={{ duration: 500, y: -100 }} class="grid grid-cols-2 gap-2">
      <div class="flex flex-col">
        <div class="uppercase">Full Name - Cutter:</div>
        <input class="col-span-3" type="text" bind:value={cutterFN} />
      </div>
      <div class="flex flex-col">
        <div class="uppercase">Full Name - Meterige:</div>
        <input class="col-span-3" type="text" bind:value={meterigeFN} />
      </div>
    </div>
    <div in:slide={{ duration: 500, y: -100 }} class="grid grid-cols-2 gap-2">
      <div class="flex flex-col">
        <div class="uppercase">Full Name - Quality:</div>
        <input class="col-span-3" type="text" bind:value={qualityFN} />
      </div>
    </div>
    <!--  -->
    <!--  -->
    <div in:slide={{ duration: 500, y: -100 }} class="grid grid-cols-2 gap-2">
      <div class="flex flex-col">
        <div class="uppercase">description:</div>
        <textarea
          class="col-span-3 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={description}
          rows="4"
        />
      </div>
      <div class="flex flex-col">
        <div class="uppercase">framing:</div>
        <textarea
          class="col-span-3 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={framing}
          rows="4"
        />
      </div>
    </div>
    <div in:slide={{ duration: 500, y: -100 }} class="grid grid-cols-2 gap-2">
      <div class="flex flex-col">
        <div class="uppercase">upholsterer:</div>
        <input
          class="col-span-3 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={upholsterer}
        />
      </div>
    </div>

    <div in:slide={{ duration: 500, y: -100 }} class="grid grid-cols-2 gap-2">
      <QuillEditor
        label="quality"
        initValue={quality}
        on:contentChange={(e) => {
          quality = e.detail;
        }}
      />
      <QuillEditor
        label="meterige"
        initValue={meterage}
        on:contentChange={(e) => (meterage = e.detail)}
      />
    </div>

    <div in:slide={{ duration: 500, y: -100 }} class="grid grid-cols-2 gap-2">
      <QuillEditor
        label="cutter"
        initValue={cutter}
        on:contentChange={(e) => (cutter = e.detail)}
      />
      <QuillEditor
        label="cushions"
        initValue={cushions}
        on:contentChange={(e) => (cushions = e.detail)}
      />
    </div>

    <div in:slide={{ duration: 500, y: -100 }} class="grid grid-cols-2 gap-2">
      <div class="flex flex-col">
        <div class="uppercase">fabric Info:</div>
        <textarea
          class="col-span-3 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={fabricInfo}
          rows="4"
        />
      </div>
      <div class="flex flex-col">
        <div class="uppercase">ADDITIONAL NOTES - COMMENTS:</div>
        <textarea
          class="col-span-3 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={notes}
          rows="4"
        />
      </div>
    </div>
    <div in:slide={{ duration: 500, y: -100 }} class="grid grid-cols-2 gap-2">
      <div class="flex flex-col">
        <div class="uppercase">rep/Foaming:</div>
        <textarea
          class="col-span-3 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={repFoaming}
          rows="4"
        />
      </div>
    </div>
  {/if}
  <!-- ---------------------------------------------------------- -->
  <!-- ---------------------------------------------------------- -->
  {#if uploading}
    <div class="grid grid-cols-1 gap-2">
      <div class="flex items-center justify-center btn btn-primary-outline">
        <Wave size="25" color="rgb(244,162,97)" unit="px" />
        <span class="ml-4">Please wait...</span>
      </div>
    </div>
  {:else}
    <!-- else content here -->
    <div in:slide={{ duration: 500, y: -100 }} class="grid grid-cols-2 gap-2">
      <button class="btn btn-primary-outline" on:click={handleClear}>
        <i class="fas fa-times-circle mr-3" />
        Clear Form
      </button>
      <button class="btn btn-primary">
        <i class="fas fa-check-circle mr-3" />
        Save to Database
      </button>
    </div>
  {/if}
</form>

<JobCardPrint
  {_id}
  {jobType}
  {customerID}
  {orderID}
  {delDate}
  {department}
  {departmentTask}
  {sprayPaint}
  {foam}
  {assembly}
  {machinist}
  {description}
  {framing}
  {upholsterer}
  {quality}
  {fabricInfo}
  {notes}
  {repFoaming}
  {meterage}
  {cutter}
  {cushions}
  {framingFN}
  {foamingFN}
  {fabricInfoFN}
  {cushionsFN}
  {cutterFN}
  {meterigeFN}
  {qualityFN}
  show={showPrint}
  on:close={() => (showPrint = false)}
/>
